import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/City";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add City
function Add({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const [isLoader, setIsLoader] = useState(false);
  const [countryOpt, setCurrencyOpt] = useState([]);
  const [stateOpt, setStateOpt] = useState([]);
  const fieldArr = [
    {
      id: 0,
      title: "Country",
      name: "country_id",
      type: "Dropdown",
      options: countryOpt,
    },
    {
      id: 1,
      title: "State",
      name: "state_id",
      type: "Dropdown",
      options: stateOpt,
    },
    { id: 2, title: "Title", name: "name", type: "TextInput" },
    {
      id: 3,
      title: "Latitude",
      name: "latitude",
      type: "TextInput",
      is_number: true,
    },
    {
      id: 4,
      title: "Longitude",
      name: "longitude",
      type: "TextInput",
      is_number: true,
    },
    { id: 5, title: "Is Rental", name: "is_rental", type: "SwitchInput" },
    {
      id: 6,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];
  // const mapRef = React.createRef();
  const [fields, setFields] = useState({});
  // const [flyTo, setFlyTo] = useState({
  //   center: [13.400860176449603, 52.51898046055597], zoom: 12 , speed: 1
  // });
  const [errors, setErrors] = useState({
    name: "",
    country_id: "",
    state_id: "",
    status: "",
  });

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.name) {
      error["name"] = "Please enter city title";
      flag = false;
    }

    if (!fields.country_id) {
      error["country_id"] = "Please select country";
      flag = false;
    }

    if (!fields.state_id) {
      error["state_id"] = "Please select state";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    if (!fields.latitude) {
      error["latitude"] = "Please select latitude";
      flag = false;
    }
    if (!fields.longitude) {
      error["longitude"] = "Please select longitude";
      flag = false;
    }
    // if (!fields.polygon) {
    //   error['polygon'] = "Please select polygon"
    //   flag = false
    // }
    setErrors({ ...error });
    return flag;
  }

  function getCountryDatas() {
    configuration
      .getAPI({ url: "country/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.country_id;
              element.id = element.country_id;

              return element;
            });
          }
          setCurrencyOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  function getStateDatas(params) {
    configuration
      .getAPI({ url: "state/list", params })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.state_id;
              element.id = element.state_id;

              return element;
            });
          }
          setStateOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "CITY");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });
    getCountryDatas();
    // getStateDatas();
  }, []);

  function handleChange(field, e) {
    if (field === "polygon" || field === "is_rental") {
      setFields({ ...fields, [field]: e });
      return;
    }

    if (field === "country_id" && !e.target.value) {
      setStateOpt([]);
    }
    if (field === "country_id" && e.target.value) {
      getStateDatas({ country_id: e.target.value });
      setFields({ ...fields, ["state_id"]: "", [field]: e.target.value });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }
  // function handleChange(field, e) {
  //   setFields({ ...fields, [field]: e.target.value });
  // }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "city/create", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/city");
            toast.success("Record added successfully");
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addCity} />
      <AddEditSection
        title="Add City"
        path="/city"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
